import { CisDistributorContactsCard } from './contacts';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from './i18n';
import './App.css';

const logo = process.env.PUBLIC_URL + '/images/logo.png';

function BuyCisPage() {
  const { href, messages } = useLanguage();
  const copy = messages.order;

  return (
    <div className="page">
      <header className="hero hero-compact">
        <nav className="topbar" aria-label={messages.navigation}>
          <a className="brand" href={href('/')} aria-label={messages.brandPlain}>
            <img src={logo} className="brand-logo" alt={messages.logoAlt} />
            <span>{messages.brand}</span>
          </a>
          <LanguageSwitcher />
        </nav>
      </header>

      <main>
        <section className="section buy-page">
          <a className="back-link" href={href('/')}>
            ← {messages.home}
          </a>

          <div className="section-heading">
            <p className="eyebrow">{copy.cisRegion}</p>
            <h1 className="buy-page-title">{copy.cisTitle}</h1>
            <p className="hero-lead">{copy.cisIntro}</p>
          </div>

          <div className="buy-contacts-stack">
            <section className="contact-section">
              <div>
                <p className="eyebrow">{copy.distributor}</p>
                <h2>{copy.cisCompany}</h2>
                <p className="hero-lead">{copy.cisCompanyNote}</p>
              </div>
              <CisDistributorContactsCard />
            </section>
          </div>
        </section>

        <section className="notice">
          <strong>{messages.important}</strong> {messages.disclaimer}
        </section>
      </main>
    </div>
  );
}

export default BuyCisPage;
